export default "__VITE_ASSET__4mt7tlHE__"